export enum PaymentCadence {
  Monthly = 1,
  Quarterly = 2
}
